<app-modal [title]="'Nova pergunta'" (onCloseClick)="fechar()" (onSaveClick)="salvar()" [saveLabel]="tituloSave"
    [hideCancel]="true">
    <div class="row mb-7">
        <div class="form-group">
            <label class="form-label required" for="pergunta">Pergunta:</label>
            <input required type="text" class="form-control" name="pergunta" id="pergunta" maxlength="256"
                placeholder="Já gerenciou mídias sociais?" [(ngModel)]="pergunta.avaliacao" #perguntaModel="ngModel"
                #perguntaInput="ngModel" />

            <abp-validation-summary [control]="perguntaModel"></abp-validation-summary>
        </div>
    </div>

    <div class="row mb-7">
        <h2 class="subtitulo">
            <h2 class="subtitulo">
                Opções disponíveis ({{ respostas && respostas.length ? respostas.length : 0 }}/3):
            </h2>
        </h2>
    </div>

    <div class="row">
        <div class="form-group col-12 col-md-9">
            <input required type="text" class="form-control" name="resposta" id="resposta" maxlength="256"
                placeholder="Ex: Sim" [(ngModel)]="resposta" #respostaModel="ngModel" #respostaInput="ngModel" />
        </div>
        <div class="col-12 col-md-3">
            <button type="button" class="btn-adicionar" (click)="adicionarResposta()">Adicionar</button>
        </div>
    </div>
    <div class="row mb-12">
        <div class="card-body table-responsive p-0">
            <table class="table text-nowrap">
                <tbody>
                    <tr *ngFor="let resposta of respostas; let i = index">
                        <td class="align-middle">
                            <ng-container *ngIf="i !== indiceEdicao; else campoEdicao">
                                <span class="competencia-nome">{{ resposta?.resposta }}</span>
                            </ng-container>
                            <ng-template #campoEdicao>
                                <input type="text" [(ngModel)]="respostaEditavel.resposta" class="form-control"
                                    (keyup.enter)="salvarEdicao()" (blur)="cancelarEdicao()" />
                            </ng-template>
                        </td>

                        <td class="align-middle text-right">
                            <button *ngIf="indiceEdicao !== i" type="button" class="btn btn-sm btn-icon btn-edit"
                                (click)="iniciarEdicao(i, resposta)">
                                <img src="../../../../assets/img/vagas/edit_vaga.svg" alt="Editar" class="icon-svg">
                            </button>

                            <button *ngIf="indiceEdicao === i" type="button" class="btn btn-sm btn-icon btn-save"
                                (click)="salvarEdicao()">
                                <img src="../../../../assets/img/vagas/edit_vaga.svg" alt="Salvar" class="icon-svg">
                            </button>

                            <button *ngIf="indiceEdicao === i" type="button" class="btn btn-sm btn-icon btn-cancel"
                                (click)="cancelarEdicao()">
                                <img src="../../../../../assets/img/vagas/close_modal.svg" alt="Cancelar"
                                    class="icon-svg">
                            </button>

                            <button *ngIf="indiceEdicao !== i" type="button" class="btn btn-sm btn-icon btn-delete"
                                (click)="removerResposta(i)">
                                <img src="../../../../assets/img/vagas/delete_vaga.svg" alt="Deletar" class="icon-svg">
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</app-modal>